module.exports = {
  back: 'Voltar',
};
